import { useParams } from "react-router";
import axios from "axios";
import { useEffect, useState } from "react";
import { Box } from "@mui/system";
import { Grid } from "@mui/material";
import { Stack } from "@mui/system";
import { Typography } from "@mui/material";
import Dashboard from "./Dashboard";
import HeaderLogoOnly from "./HeaderLogoOnly";
import VoteButton from "./VoteButton";
// import {Dashboard} from "../components/Dashboard.js"
const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

function VideoPage() {
  const [allVideos, setAllVideos] = useState([]);
  const [video, setVideo] = useState("");
  let { id } = useParams();
  const [videoId, setVideoId] = useState(id);
  const URL = "https://7168661e-436d-4a67-bc22-cb1049597751.mock.pstmn.io/v1";

  useEffect(() => {
    getVideoFromId(id);
    getAllVideos(URL);
    incrementViewCount(URL);
  }, []);

  async function getVideoFromId(id) {
    console.log("Getting video from id", id);
    const response = await axios.get(URL + "/video/" + id);
    const video = response.data;
    setVideo(video);
  }

  async function getAllVideos(URL) {
    const response = await axios.get(URL + "/videos");
    const result = response.data.videos;
    setAllVideos(result);
  }

  async function incrementViewCount(URL) {
    try {
      const response = await axios.patch(URL + `/videos/${videoId}/views`);
      console.log("response for view increment", response);
    } catch (error) {}
  }
  console.log(
    "video Link",
    video,
    video.videoLink,
    "allVideos",
    allVideos,
    "id",
    id
  );
  return (
    <>
      <HeaderLogoOnly />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={10} md={10} lg={10}>
          <Stack spacing={1}>
            <iframe
              width="100%"
              src={`https://www.${video.videoLink}`}
              title={video.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{
                width: "100%",
                aspectRatio: `16/9`,
              }}
            ></iframe>
            <Typography color="primary" variant="h5" component="div">
              {video.title}
            </Typography>

            <Typography color="primary" variant="p" component="div">
              {video.contentRating} {bull} {video.releaseDate}
            </Typography>
            <VoteButton videoId={videoId} />
          </Stack>
          <Dashboard setVideoId={setVideoId} allVideos={allVideos} />
        </Grid>
      </Grid>
    </>
  );
}

export default VideoPage;
